module.exports = __webpack_public_path__ + "img/online-news.21d18646.png";